import styled from 'styled-components'
import ArticleCard from '../ArticleCard'


const OpinionGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 15vh);

    background: #9F8B70;

    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 48px;

    border: 1px solid black;
    line-height: 13vh;

    .O1 {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
    }
    .P {
        grid-row: 1;
        grid-column: 2;
        border: inherit;

    }
    .I1 {
        grid-row: 1;
        grid-column: 3;
        border: inherit;

    }
    .N1 {
        grid-row: 2;
        grid-column: 1;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .I2 {
        grid-row: 2;
        grid-column: 2;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .O2 {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
                border-bottom: 0px solid black;

    }
    .N2 {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
                border-bottom: 0px solid black;

    }

    .Blank1 {
        grid-row: 1;
        grid-column: 4;
        border: inherit;

    }
`;

const ArticleGrid = styled("div")`
    background: #9F8B70;
`

const OpinionMobile = (props) => {
    let a1 = props.opinion[0];
    let a2 = props.opinion[1];
    let a3 = props.opinion[2];
    return (
        <>
            <OpinionGrid>
                <div class="O1">O</div>
                <div class="P">P</div>
                <div class="I1">I</div>
                <div class="N1">N</div>
                <div class="I2">I</div>
                <div class="O2">O</div>
                <div class="N2">N</div>


                <div class="Blank1"></div>

            </OpinionGrid>
            <ArticleGrid>

                <div class="A1">
                    <ArticleCard
                        position="left"
                        article_title={a1.article_title}
                        article_byline={a1.article_byline}
                        article_image={a1.article_image}
                        article_url={a1.article_url}
                        ></ArticleCard>
                </div>
                <div class="A2">
                    <ArticleCard
                        position='right'
                        article_title={a2.article_title}
                        article_byline={a2.article_byline}
                        article_image={a2.article_image} article_url={a2.article_url}></ArticleCard>
                </div>
                <div class="A3">
                    <ArticleCard
                        position='left'
                        article_title={a3.article_title}
                        article_byline={a3.article_byline}
                        article_image={a3.article_image} article_url={a3.article_url}></ArticleCard>
                </div>
            </ArticleGrid>
        </>
    )
}

export default OpinionMobile;